import router from '@/router';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('VueRouterWrapperCtrl', vueRouterWrapperCtrl);

    function vueRouterWrapperCtrl($scope) {
        $scope.router = router;
    }
})();
